<div class="flex md:flex-row flex-col gap-4 justify-start max-w-[858px] w-full">
  <ng-container *ngFor="let button of this.FilteredButtons()">
    <label [attr.for]="button.id" class="visual-checkbox visual-col">
      <input
        type="checkbox"
        [attr.id]="button.id"
        class="opacity-0 absolute h-0 w-0"
        (click)="toggleSelect(button.id)"
        [checked]="button.isToggled"
      />
      <span class="">{{ button.title }}</span>
    </label>
  </ng-container>
</div>
